'use strict'

import React from 'react';
import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';

import {RegisterProgramme} from '../NewProject.jsx';

export class ProgrammeProperties extends React.Component {
  render() {
    return (
      <div>
        <div style={{textAlign: "center", display:"flex", justifyContent:"center"}}>
          <div style={{width:1016}}>
            <RegisterProgramme {...this.props} project={this.props.programme}/>
          </div>
        </div>
      </div>
    )
  }
}

export default class ProgrammePropertiesPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props} project={this.props.programme}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu} project={this.props.programme}>
        <ProgrammeProperties {...this.props}/>
      </Layout>
    );
  }

}



// WEBPACK FOOTER //
// ./views/programme/ProgrammeProperties.jsx